import {
    SET_PRODUCTSGUIDE,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
    CLEAR_PRODUCTS_GUIDE,
    VALIDATE_PRODUCTS,
    CLEAR_VALIDATED_PRODUCTS,
    GET_PRODUCTSGUIDE,
    GET_PRODUCT_DETAILS,
    SORT_PRODUCT_DETAILS,
    UPDATE_CART_DATA,
    UPDATE_CART_PRODUCTS_QUANTITY,
    CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT,
    SET_CART_DATA,
    SET_CART_DATA_PRICE_OVERRIDE,
    GET_PRODUCTS,
    GET_PRODUCTSTEMPLATESFILTER,
    SET_PRODUCTSTEMPLATESFILTER,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST,
    GET_TEMPLATE_DETAILS,
    CREATE_PRODUCT_TEMPLATE,
    RESET_CREATE_TEMPLATE,
    UPDATE_PRODUCT_TEMPLATE,
    GET_DATA_FOR_PRODUCT_TEMPLATE,
    SET_EXPANDED_FILTER_VIEW,
    SET_PROGRESS_BAR_STATUS,
    RESET_PROGRESS_BAR_STATUS,
    SET_PROGRESS_BAR_CURRENT_STEP,
    SET_PROGRESS_BAR_EDIT_MODE,
    GET_PRICES_FOR_ITEMS,
    RESET_PRICES_FOR_ITEMS,
    STORE_CONSIGNMENT_ADD_DETAILS,
    RESET_CART_DATA,
    STORE_ITEM_TABLE_DATA,
    UPDATE_CART_DATA_PRICEOVERRIDE,
    CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD,
    CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
    CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
    CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST,
    CONSIGNMENT_ADD_RESET_PO_ATTACHMENT,
    CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW,
    RESET_CONSIGNMENT_ADD_REFERENCE,
    INITIAL_CONSIGNMENT_ADD_DATA,
    SET_ORDER_FROM_REPORT_USAGE,
    CONSIGNMENT_ADD_ORDER_FROM_USAGE_DETAILS,
    GET_DROPDOWN_OPTIONS,
    SET_CONSIGNMENT_ADD_CU_IN_PROGRESS,
    SET_CONSIGNMENT_ADD_ORDER_SUBMITTED,
    RESET_CREATECONSIGNMENT_ADD,
    UPDATE_PRODUCT_TEMPLATE_LIST,
    RESET_DERIVED_TERRITORIES,
    STORE_SELECTED_PRODUCTS_DATA,
    RESET_STORE_ITEM_TABLE_DATA,
    SET_PRODUCT_TEMPLATE_UID,
    GET_PRODUCT_BUNDLE,
    GET_CONSIGNMENT_ADD_MYCASEREF,
    GET_DROPDOWN,
    SET_SURGERY_NUMBER,
    GET_TRANSFER_RECIPIENT_METHODS,
    CLEAR_TRANSFER_RECIPIENTS,
} from './actionTypes';
export const SET_SURGERY_DETAILS = 'CONSIGNMENT_ADD: SET_SURGERY_DETAILS';
export const UPDATE_CART_DATA_SHIPPING =
    'CONSIGNMENT_ADD: UPDATE_CART_DATA_SHIPPING';
export const SET_SHIPPING_DETAILS = 'CONSIGNMENT_ADD: SET_SHIPPING_DETAILS';
export const RESET_SHIPPING_DETAILS = 'CONSIGNMENT_ADD: RESET_SHIPPING_DETAILS';
export const SET_SHIPPING_DETAILS_EDIT_MODE =
    'CONSIGNMENT_ADD: SET_SHIPPING_DETAILS_EDIT_MODE';
export const SET_SHIPPING_ADDRESS = 'SET_SHIPPING_ADDRESS';
export const GET_DROPDOWN_SUCCESS = 'CONSIGNMENT_ADD: GET_DROPDOWN_SUCCESS';
export const GET_DROPDOWN_FAILURE = 'CONSIGNMENT_ADD: GET_DROPDOWN_FAILURE';
export const SAVE_SURGERY_DETAILS = 'CONSIGNMENT_ADD: SAVE_SURGERY_DETAILS';
export const SAVE_SURGERY_DETAILS_SUCCESS =
    'CONSIGNMENT_ADD: SAVE_SURGERY_DETAILS_SUCCESS';
export const SAVE_SURGERY_DETAILS_FAILURE =
    'CONSIGNMENT_ADD: SAVE_SURGERY_DETAILS_FAILURE';
export const UPDATE_SURGERY_DETAILS = 'CONSIGNMENT_ADD: UPDATE_SURGERY_DETAILS';
export const UPDATE_SURGERY_DETAILS_SUCCESS =
    'CONSIGNMENT_ADD: UPDATE_SURGERY_DETAILS_SUCCESS';
export const UPDATE_SURGERY_DETAILS_FAILURE =
    'CONSIGNMENT_ADD: UPDATE_SURGERY_DETAILS_FAILURE';
export const GET_PRODUCTS_BULK = 'CONSIGNMENT_ADD_PRODUCTS:GET_PRODUCTS_BULK';
export const GET_PRODUCTS_BULK_SUCCESS =
    'CONSIGNMENT_ADD_PRODUCTS:GET_PRODUCTS_BULK_SUCCESS';
export const GET_PRODUCTS_BULK_FAILURE =
    'CONSIGNMENT_ADD_PRODUCTS:GET_PRODUCTS_BULK_FAILURE';
export const SET_PRODUCTS = 'CONSIGNMENT_ADD_PRODUCTS:SET_PRODUCTS';
export const CLEAR_PRODUCTS = 'CONSIGNMENT_ADD_PRODUCTS:CLEAR_PRODUCTS';

export const SET_PRICING_NOTES = 'SET_PRICING_NOTES';

export const SET_HOLIDAY_LIST_AND_UPCOMING_7_BUSINESS_DAYS_FOR_CONSIGNMENT_ADD =
    'SET_HOLIDAY_LIST_AND_UPCOMING_7_BUSINESS_DAYS_FOR_CONSIGNMENT_ADD';

export const GET_SHIPPING_METHODS =
    'CONSIGNMENT_ADD_SHIPPING: GET_SHIPPING_METHODS';
export const GET_SHIPPING_METHODS_SUCCESS =
    'CONSIGNMENT_ADD_SHIPPING: GET_SHIPPING_METHODS_SUCCESS';
export const GET_SHIPPING_METHODS_FAILURE =
    'CONSIGNMENT_ADD_SHIPPING: GET_SHIPPING_METHODS_FAILURE';
export const GET_SHIP_TO_ADDRESS =
    'CONSIGNMENT_ADD_SHIPPING: GET_SHIP_TO_ADDRESS';
export const GET_SHIP_TO_ADDRESS_SUCCESS =
    'CONSIGNMENT_ADD_SHIPPING: GET_SHIP_TO_ADDRESS_SUCCESS';
export const GET_SHIP_TO_ADDRESS_FAILURE =
    'CONSIGNMENT_ADD_SHIPPING: GET_SHIP_TO_ADDRESS_FAILURE';
export const GET_BATCH_ALLOCATIONS = 'SHIPPING: GET_BATCH_ALLOCATIONS';
export const GET_BATCH_ALLOCATIONS_SUCCESS =
    'SHIPPING: GET_BATCH_ALLOCATIONS_SUCCESS';
export const GET_BATCH_ALLOCATIONS_FAILURE =
    'SHIPPING: GET_BATCH_ALLOCATIONS_FAILURE';

export const SET_VISUALIZATION_INSPECTION =
    'SUBMIT: SET_VISUALIZATION_INSPECTION';
//Surgery Notes
export const HANDLE_SURGERY_NOTES = 'HANDLE_SURGERY_NOTES';
export const GET_SURGERY_DETAILS = 'CONSIGNMENT_ADD:GET_SURGERY_DETAILS';
export const GET_SURGERY_DETAILS_SUCCESS =
    'CONSIGNMENT_ADD:GET_SURGERY_DETAILS_SUCCESS';
export const GET_SURGERY_DETAILS_FAILURE =
    'CONSIGNMENT_ADD:GET_SURGERY_DETAILS_FAILURE';
export const RESET_CONSIGNMENT_ADD_DETAILS = 'RESET_CONSIGNMENT_ADD_DETAILS';
export const RESET_CONSIGNMENT_ADD_DETAILS_DATA =
    'CONSIGNMENT_ADD: RESET_CONSIGNMENT_ADD_DETAILS_DATA';
export const CHANGE_SHIPPING_SEGMENT_INDEX = 'CHANGE_SHIPPING_SEGMENT_INDEX';

export const DISABLE_SURGERY_DATE = 'DISABLE_SURGERY_DATE';
export const CURRENT_SURGERY_DATE_SELECTED = 'CURRENT_SURGERY_DATE_SELECTED';
export const CHANGE_ACKNOWLEGMENT_VIEW =
    'CONSIGNMENT_ADD:CHANGE_ACKNOWLEGMENT_VIEW';

export const SET_UNSAVED_CHANGES_POP_UP =
    'CONSIGNMENT_ADD:SET_UNSAVED_CHANGES_POP_UP';

export const PHYSICIAN_LOAD_ALL_LOADING = 'PHYSICIAN_LOAD_ALL_LOADING';
export const SET_ROUTE_PATH_FOR_CONSIGNMENT_ADD_UNSAVED_CHANGES_POP_UP =
    'CONSIGNMENT_ADD:SET_ROUTE_PATH_FOR_CONSIGNMENT_ADD_UNSAVED_CHANGES_POP_UP';

//set recently used PhysicianS
export const PUT_RECENTLY_USED_PHYSICIANS = 'PUT_RECENTLY_USED_PHYSICIANS';
export const PUT_RECENTLY_USED_PHYSICIANS_SUCCESS =
    'PUT_RECENTLY_USED_PHYSICIANS_SUCCESS';
export const PUT_RECENTLY_USED_PHYSICIANS_FAILURE =
    'PUT_RECENTLY_USED_PHYSICIANS_FAILURE';

//get derived territories (non-interventional)
export const GET_DERIVED_TERRITORIES =
    'CONSIGNMENT_ADD: GET_DERIVED_TERRITORIES';
export const SET_DERIVED_TERRITORIES_SUCCESS =
    'CONSIGNMENT_ADD: SET_DERIVED_TERRITORIES_SUCCESS';
export const SET_DERIVED_TERRITORIES_FAILURE =
    'CONSIGNMENT_ADD: SET_DERIVED_TERRITORIES_FAILURE';
export const SET_CONSIGNMENT_ADD_DETAILS_GENERIC =
    'CONSIGNMENT_ADD: SET_CONSIGNMENT_ADD_DETAILS_GENERIC';
export const CLEAR_SPECFIC_DROPDOWN_LIST =
    'CONSIGNMENT_ADD: CLEAR_SPECFIC_DROPDOWN_LIST';
export const GET_HOLIDAY_LIST = 'GET_HOLIDAY_LIST';
export const GET_HOLIDAY_LIST_SUCCESS = 'GET_HOLIDAY_LIST_SUCCESS';
export const SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS =
    'SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS';
export const GET_HOLIDAY_LIST_ERROR = 'GET_HOLIDAY_LIST_ERROR';
export const CLEAR_SHIPPING_ADDRESS = 'CLEAR_SHIPPING_ADDRESS';
export const RESET_CREATE_UPDATE_SURGERY = 'RESET_CREATE_UPDATE_SURGERY';
export const GET_CONSIGNMENT_ADD_DETAILS =
    'CONSIGNMENT_ADD: GET_CONSIGNMENT_ADD_DETAILS';
export const GET_CONSIGNMENT_ADD_DETAILS_SUCCESS =
    'CONSIGNMENT_ADD: GET_CONSIGNMENT_ADD_DETAILS_SUCCESS';
export const GET_CONSIGNMENT_ADD_DETAILS_FAILURE =
    'CONSIGNMENT_ADD: GET_CONSIGNMENT_ADD_DETAILS_FAILURE';
export const SAVE_CONSIGNMENT_ADD_DETAILS =
    'CONSIGNMENT_ADD: SAVE_CONSIGNMENT_ADD_DETAILS';
export const SAVE_CONSIGNMENT_ADD_DETAILS_SUCCESS =
    'CONSIGNMENT_ADD: SAVE_CONSIGNMENT_ADD_DETAILS_SUCCESS';
export const SAVE_CONSIGNMENT_ADD_DETAILS_FAILURE =
    'CONSIGNMENT_ADD: SAVE_CONSIGNMENT_ADD_DETAILS_FAILURE';
export const RESET_CREATE_UPDATE_CONSIGNMENT_ADD =
    'RESET_CREATE_UPDATE_CONSIGNMENT_ADD';
export const UPDATE_CONSIGNMENT_ADD_DETAILS =
    'CONSIGNMENTADD: UPDATE_CONSIGNMENT_ADD_DETAILS';
export const UPDATE_CONSIGNMENT_ADD_DETAILS_SUCCESS =
    'CONSIGNMENT_ADD: UPDATE_CONSIGNMENT_ADD_DETAILS_SUCCESS';
export const UPDATE_CONSIGNMENT_ADD_DETAILS_FAILURE =
    'CONSIGNMENT_ADD: UPDATE_CONSIGNMENT_ADD_DETAILS_FAILURE';
export const VALIDATE_ACCOUNT = 'VALIDATE_ACCOUNT';
export const VALIDATE_ACCOUNT_SUCCESS =
    'VALIDATE_ACCOUNT_SUCCESS';
export const VALIDATE_ACCOUNT_FAILURE =
    'VALIDATE_ACCOUNT_FAILURE';
export const RESET_VALIDATE_ACCOUNT = 'CONSIGNMENT_ADD: RESET_VALIDATE_ACCOUNT';
export const STORE_CONSIGNMENT_ADD_REFERENCE =
    'CONSIGNMENT_ADD: STORE_CONSIGNMENT_ADD_REFERENCE';
export const setSurgeryDetails = (surgeryDetails) => {
    return {
        type: SET_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

//
export const saveSurgery = (surgeryDetails) => {
    return {
        type: SAVE_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

export const updateSurgery = (surgeryDetails) => {
    return {
        type: UPDATE_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

export const setCartData = (cartData) => {
    return {
        type: SET_CART_DATA,
        payload: cartData,
    };
};
export const setSurgeryNumber = (numberOfSurgeries) => {
    return {
        type: SET_SURGERY_NUMBER,
        payload: numberOfSurgeries,
    };
};
export const setCartDataForPriceOverride = (cartData) => {
    return {
        type: SET_CART_DATA_PRICE_OVERRIDE,
        payload: cartData,
    };
};

export const updateCartData = (
    operation,
    productKey,
    isSet,
    childProductKey
) => {
    return {
        type: UPDATE_CART_DATA,
        payload: { operation, productKey, isSet, childProductKey },
    };
};

export const updateCartProductsQuantity = (
    quantity,
    productKey,
    isSet,
    childProductKey
) => {
    return {
        type: UPDATE_CART_PRODUCTS_QUANTITY,
        payload: {
            quantity: quantity,
            productKey: productKey,
            isSet: isSet,
            childProductKey: childProductKey,
        },
    };
};
export const setSurgeryDetailsGeneric = (data) => {
    return {
        type: SET_CONSIGNMENT_ADD_DETAILS_GENERIC,
        payload: data,
    };
};
export const updateCartDataPriceOverride = (
    productDetails,
    overriddenReason,
    pricingNotes,
    overrideDiscount
) => {
    return {
        type: UPDATE_CART_DATA_PRICEOVERRIDE,
        payload: {
            products: productDetails,
            overriddenReason: overriddenReason,
            pricingNotes: pricingNotes,
            overrideDiscount: overrideDiscount,
        },
    };
};

// export const updateCartDataPriceOverrideOverAllDiscount = (
//     productDetails,
//     value
// ) => {
//     //nami
//     return {
//         type: UPDATE_CART_DATA_PRICEOVERRIDE_OVERALL_DISCOUNT,
//         payload: { productDetails, value },
//     };
// };

export const updateCartDataShipping = (newFields, productKeys) => {
    return {
        type: UPDATE_CART_DATA_SHIPPING,
        payload: { newFields, productKeys },
    };
};

export const setShippingDetails = (shippingDetails) => {
    return {
        type: SET_SHIPPING_DETAILS,
        payload: shippingDetails,
    };
};

export const resetShippingDetails = () => {
    return {
        type: RESET_SHIPPING_DETAILS,
    };
};

export const setShippingDetailsEditMode = (shippingDetails) => {
    return {
        type: SET_SHIPPING_DETAILS_EDIT_MODE,
        payload: shippingDetails,
    };
};
export const setShippingAddress = (shippingDetails) => {
    return {
        type: SET_SHIPPING_ADDRESS,
        payload: shippingDetails,
    };
};

export const getDropdownValues = (dropDownDetails) => {
    return {
        type: GET_DROPDOWN,
        payload: dropDownDetails,
    };
};
export const setProductsGuide = (productsGuideList, name) => {
    return {
        type: SET_PRODUCTSGUIDE,
        payload: productsGuideList,
        name: name,
    };
};

export const searchProducts = (queryParam, isBundle) => {
    return {
        type: GET_PRODUCTS,
        payload: { queryParam: queryParam, isBundle: isBundle },
    };
};

export const searchProductsBulk = (cfns) => {
    return {
        type: GET_PRODUCTS_BULK,
        payload: cfns,
    };
};

export const clearProducts = () => {
    return {
        type: CLEAR_PRODUCTS,
    };
};

export const getProductsGuide = () => {
    return {
        type: GET_PRODUCTSGUIDE,
    };
};

export const sortProductDetails = (data) => {
    return {
        type: SORT_PRODUCT_DETAILS,
        payload: data,
    };
};
export const setProgressBarStatus = (completedStep) => {
    return {
        type: SET_PROGRESS_BAR_STATUS,
        payload: completedStep,
    };
};

export const reSetProgressBarStatus = () => {
    return {
        type: RESET_PROGRESS_BAR_STATUS,
    };
};

export const setProgressBarCurrentStep = (currentStep) => {
    return {
        type: SET_PROGRESS_BAR_CURRENT_STEP,
        payload: currentStep,
    };
};

export const setProgressBarStateEditMode = (data) => {
    return {
        type: SET_PROGRESS_BAR_EDIT_MODE,
        payload: data,
    };
};

export const validateProducts = (products) => {
    return {
        type: VALIDATE_PRODUCTS,
        payload: products,
    };
};

export const clearValidatedProducts = () => {
    return {
        type: CLEAR_VALIDATED_PRODUCTS,
    };
};

export const getProductDetails = (data) => {
    return {
        type: GET_PRODUCT_DETAILS,
        payload: data,
    };
};

export const getProductsTemplatesFilter = () => {
    return {
        type: GET_PRODUCTSTEMPLATESFILTER,
    };
};

export const setProductsTemplatesFilter = (productsTemplatesFilter) => {
    return {
        type: SET_PRODUCTSTEMPLATESFILTER,
        payload: productsTemplatesFilter,
    };
};

export const getShippingMethods = (payload) => {
    return {
        type: GET_SHIPPING_METHODS,
        payload,
    };
};

export const getShipToAddress = (payload) => {
    return {
        type: GET_SHIP_TO_ADDRESS,
        payload: payload,
    };
};

export const getShippingBatchAllocations = (cfn) => {
    return {
        type: GET_BATCH_ALLOCATIONS,
        payload: cfn,
    };
};
export const handleSurgeryNotes = (data) => {
    return {
        type: HANDLE_SURGERY_NOTES,
        payload: data,
    };
};
export const setPricingNotes = (data) => {
    return {
        type: SET_PRICING_NOTES,
        payload: data,
    };
};
export const setVisualizationInspection = (value) => {
    return {
        type: SET_VISUALIZATION_INSPECTION,
        payload: value,
    };
};

export const getSurgeryDetails = (myCaseRef, updateState, resourceType, isFromOrderHistory = false, isCopyFromSummary = false) => {
    return {
        type: GET_SURGERY_DETAILS,
        payload: { myCaseRef, updateState, resourceType, isFromOrderHistory, isCopyFromSummary },
    };
};
export const resetConsignmentAddDetails = () => {
    return {
        type: RESET_CONSIGNMENT_ADD_DETAILS_DATA,
        payload: '',
    };
};
export const changeShippingSegmentIndex = (index) => {
    return {
        type: CHANGE_SHIPPING_SEGMENT_INDEX,
        payload: index,
    };
};
export const changeAcknowlegmentCheckbox = (data) => {
    return {
        type: CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT,
        payload: data,
    };
};
export const changeAcknowlegmentView = (data) => {
    return {
        type: CHANGE_ACKNOWLEGMENT_VIEW,
        payload: data,
    };
};
export const disableSurgeryDate = (value) => {
    return {
        type: DISABLE_SURGERY_DATE,
        payload: value,
    };
};
export const currentSurgeryDateSelected = (value) => {
    return {
        type: CURRENT_SURGERY_DATE_SELECTED,
        payload: value,
    };
};

export const getProductsCategoryAndBrands = (data) => {
    return {
        type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
        payload: data,
    };
};

export const getProductsByBrandOrSuperCategory = (data) => {
    return {
        type: GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
        payload: data,
    };
};

export const setConsignmentAddUnsavedChangesPopUp = (value) => {
    return {
        type: SET_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};
export const setConsignmentAddCUInProgress = (value) => {
    return {
        type: SET_CONSIGNMENT_ADD_CU_IN_PROGRESS,
        payload: value,
    };
};
export const loadAllPhyscianLoading = (data) => {
    return {
        type: PHYSICIAN_LOAD_ALL_LOADING,
        payload: data,
    };
};
export const getTemplateDetails = (params, tempcategory) => {
    return {
        type: GET_TEMPLATE_DETAILS,
        payload: params,
        templatecategory: tempcategory,
    };
};
export const putRecentlyUsedPhysicians = () => {
    return {
        type: PUT_RECENTLY_USED_PHYSICIANS,
    };
};
export const setRoutePathForConsignmentAddUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_CONSIGNMENT_ADD_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const getDerivedTerritories = (value) => {
    return {
        type: GET_DERIVED_TERRITORIES,
        payload: value,
    };
};

export const getDetailedProductTemplateList = (params) => {
    return {
        type: GET_DETAILED_PRODUCT_TEMPLATE_LIST,
        payload: params,
    };
};

export const getconsignmentAddTemplateDetails = (params) => {
    return {
        type: GET_TEMPLATE_DETAILS,
        payload: params,
    };
};

export const createTemplate = (params) => {
    return {
        type: CREATE_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const resetCreateTemplate = () => {
    return {
        type: RESET_CREATE_TEMPLATE,
    };
};

export const updateDetailedconsignmentAddProductTemplateList = (params) => ({
    type: UPDATE_PRODUCT_TEMPLATE_LIST,
    payload: params,
});

export const updateconsignmentAddProductTemplate = (params) => {
    return {
        type: UPDATE_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const getRequiredDataFromOrder = (params) => {
    return {
        type: GET_DATA_FOR_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const clearSingleDropDownList = (value) => {
    return {
        type: CLEAR_SPECFIC_DROPDOWN_LIST,
        payload: value,
    };
};
export const getHolidayList = (data) => { 
    return {
        type: GET_HOLIDAY_LIST,
        payload: data,
    };
};
export const clearShippingAddress = (data) => {
    return {
        type: CLEAR_SHIPPING_ADDRESS,
        payload: data,
    };
};

export const clearShippingMethods = (data) => {
    return {
        type: CLEAR_SHIPPING_ADDRESS,
        payload: data,
    };
};

export const resetCreateOrUpdateSurgery = () => {
    return {
        type: RESET_CREATE_UPDATE_SURGERY,
    };
};
export const resetCreateconsignmentAdd = () => {
    return {
        type: RESET_CREATECONSIGNMENT_ADD,
    };
};
export const resetCreateUpdateConsignmentAdd = () => {
    return {
        type: RESET_CREATE_UPDATE_CONSIGNMENT_ADD,
    };
};

export const setExpandedFilters = (data) => {
    return {
        type: SET_EXPANDED_FILTER_VIEW,
        payload: data,
    };
};

export const clearProductsGuide = () => {
    return {
        type: CLEAR_PRODUCTS_GUIDE,
    };
};

export const getConsignmentAddDetails = (params) => {
    return {
        type: GET_CONSIGNMENT_ADD_DETAILS,
        payload: params,
    };
};
export const getConsignmentAddMyCaseRef = (params) => {
    return {
        type: GET_CONSIGNMENT_ADD_MYCASEREF,
        payload: params,
    };
};

export const saveconsignmentAdd = (consignmentAddDetails) => {
    return {
        type: SAVE_CONSIGNMENT_ADD_DETAILS,
        payload: consignmentAddDetails,
    };
};

export const updateconsignmentAdd = (consignmentAddDetails) => {
    return {
        type: UPDATE_CONSIGNMENT_ADD_DETAILS,
        payload: consignmentAddDetails,
    };
};

export const getValidateAccountDetails = (params) => {
    return {
        type: VALIDATE_ACCOUNT,
        payload: params,
    };
};

export const resetValidateAccountDetails = () => {
    return {
        type: RESET_VALIDATE_ACCOUNT,
    };
};

export const getPricesForItems = (priceItemsObj) => ({
    type: GET_PRICES_FOR_ITEMS,
    payload: priceItemsObj,
});

export const resetPricesForItems = () => ({
    type: RESET_PRICES_FOR_ITEMS,
});

export const storeSurgeryDetails = (consignmentAddData) => ({
    type: STORE_CONSIGNMENT_ADD_DETAILS,
    payload: consignmentAddData,
});

export const resetCartData = () => {
    return {
        type: RESET_CART_DATA,
    };
};

export const storeItemTableData = (itemTableData) => {
    return {
        type: STORE_ITEM_TABLE_DATA,
        payload: itemTableData,
    };
};

//ADD PO
export const usageAttachmentUpload = (formData) => ({
    type: CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD,
    payload: formData,
});

export const getPoImagePreview = (details) => {
    return {
        type: CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW,
        payload: details,
    };
};

export const resetPoDetails = () => ({
    type: CONSIGNMENT_ADD_RESET_PO_ATTACHMENT,
    payload: '',
});

export const setPOTissueImageDetails = (data) => {
    return {
        type: CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
        payload: data,
    };
};

export const setPONonTissueImageDetails = (data) => {
    return {
        type: CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
        payload: data,
    };
};

export const deleteAttachmentRequest = (id) => ({
    type: CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST,
    payload: id,
});

export const storeconsignmentAddReference = (consignmentAddData) => ({
    type: STORE_CONSIGNMENT_ADD_REFERENCE,
    payload: consignmentAddData,
});

export const resetConsignmentAddReference = () => ({
    type: RESET_CONSIGNMENT_ADD_REFERENCE,
});

export const initialconsignmentAddData = () => ({
    type: INITIAL_CONSIGNMENT_ADD_DATA,
});

export const setOrderFromReportUsage = (isOrderFromReportUsage) => ({
    type: SET_ORDER_FROM_REPORT_USAGE,
    payload: isOrderFromReportUsage,
});
export const setconsignmentAddOrderFromUsage = (myCaseRef, resourceType) => ({
    type: CONSIGNMENT_ADD_ORDER_FROM_USAGE_DETAILS,
    payload: {
        myCaseRef: myCaseRef,
        resourceType: resourceType,
    },
});

export const getDropdownOptionsRequest = (dropdownType) => ({
    type: GET_DROPDOWN_OPTIONS,
    payload: dropdownType,
});

export const setconsignmentAddOrderSubmitted = (isSubmitted) => ({
    type: SET_CONSIGNMENT_ADD_ORDER_SUBMITTED,
    payload: isSubmitted,
});

export const resetDerivedTerritories = () => ({
    type: RESET_DERIVED_TERRITORIES,
});

export const storeSelectedProducts = (selectedProducts) => ({
    type: STORE_SELECTED_PRODUCTS_DATA,
    payload: selectedProducts,
});

export const resetStoreItemTableData = (data) => ({
    type: RESET_STORE_ITEM_TABLE_DATA,
    payload: data,
});

export const setProductTemplateUID = (data) => ({
    type: SET_PRODUCT_TEMPLATE_UID,
    payload: data,
});

export const resetConsignmentAddDropDownDetails = (data) => ({
    type: RESET_CONSIGNMENT_ADD_DETAILS,
    payload: data,
});

export const searchProductsBundle = (cfns) => {
    return {
        type: GET_PRODUCT_BUNDLE,
        payload: cfns,
    };
};

export const getTransferRecipientMethods = (payload) => { 
    return {
        type: GET_TRANSFER_RECIPIENT_METHODS,
        payload,
    };
};

export const clearTransferRecipients = (data) => {
    return {
        type: CLEAR_TRANSFER_RECIPIENTS,
    };
};

